import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import style from "../constants/style";
import {
  Typo,
  ProgressBar,
  TextBody,
  WhiteHolder,
  FlexHolder,
  Flex,
  Container,
  ContentContainer,
  Button,
  ModalLoading,
  Div,
} from "../components";
import Context from "../Context";
import { FiShoppingBag } from "react-icons/fi";
import { statuses, getThaiDateFormat } from "../constants";

export const Status = () => {
  const { go, callApi } = Context();
  const { status, orderId } = useParams();
  const [tempData, setTempData] = useState(null);
  const data = {
    approved: {
      icon: "/images/status_approved.svg",
      color: "navy",
      title: "ชำระเงินสำเร็จ",
      texts: [
        "ระบบได้ทำการอนุมัติคำขอชำระเงินของท่านเรียบร้อยแล้ว!",
        localStorage.guestId
          ? ""
          : "ท่านสามารถตรวจสอบคำสั่งซื้อและลอตเตอรี่ของท่านได้ที่กระเป๋าของฉัน",
      ],
    },
    pending_offline: {
      icon: "/images/status_approved.svg",
      color: "navy",
      title: " ลอตเตอรี่ราคาขาย 80 บาทไม่มีค่าบริการ",
      texts: [
        "กรุณากดปุ่มติดต่อเจ้าหน้าที่เพื่อทำการนัดหมาย",
        "กรุณานัดหมายล่วงหน้าในเวลาทำการ 10:00 - 16:00 น. (หยุดเสาร์อาทิตย์)",
      ],
    },
    pending: {
      icon: "/images/status_pending.svg",
      color: "red",
      title: "การชำระเงินล้มเหลว",
      texts: [
        "เกิดความผิดพลาดที่ไม่คาดคิดระหว่างการแนบหลักฐานชำระเงิน",
        "ท่านสามารถแก้ไขหลักฐานการชำระเงินและติดตามสถานะการสั่งซื้อของท่านได้ใน กระเป๋าของฉัน",
      ],
    },
    paid: {
      icon: "/images/status_paid.svg",
      color: "navy",
      title: "การชำระรออนุมัติ",
      texts: [
        "  ระบบได้รับหลักฐานการชำระเงินของท่านเรียบร้อยแล้ว! เจ้าหน้าที่จะทำการตรวจสอบและอนุมัติคำสั่งซื้อของท่านโดยเร็วที่สุด ท่านสามารถติดตามสถานะการสั่งซื้อของท่านได้ใน",
      ],
    },
    shop_paid: {
      icon: "/images/status_paid.svg",
      color: "navy",
      title: "การชำระรออนุมัติ",
      texts: [
        "  ระบบได้รับหลักฐานการชำระเงินของท่านเรียบร้อยแล้ว! เจ้าหน้าที่จะทำการตรวจสอบและอนุมัติคำสั่งซื้อของท่านโดยเร็วที่สุด ท่านสามารถติดตามสถานะการสั่งซื้อของท่านได้ใน",
      ],
      button: (
        <Button
          margin="24px 0 0 0"
          width="100%"
          background="gradient2"
          hoverBg="transparent"
          hoverColor="navy"
          hoverBorder="navy"
          gap="8px"
          onClick={() => go("/shop/history")}
        >
          ประวัติการซื้อสินค้า
        </Button>
      ),
    },
    coupon_paid: {
      icon: "/images/status_paid.svg",
      color: "navy",
      title: "การชำระรออนุมัติ",
      texts: [
        "  ระบบได้รับหลักฐานการชำระเงินของท่านเรียบร้อยแล้ว! เจ้าหน้าที่จะทำการตรวจสอบและอนุมัติคำสั่งซื้อของท่านโดยเร็วที่สุด ท่านสามารถติดตามสถานะการสั่งซื้อของท่านได้ใน",
      ],
      button: (
        <Button
          margin="24px 0 0 0"
          width="100%"
          background="gradient2"
          hoverBg="transparent"
          hoverColor="navy"
          hoverBorder="navy"
          gap="8px"
          onClick={() => go("/coupon/history")}
        >
          ประวัติการซื้อ/ใช้งาน คูปอง
        </Button>
      ),
    },
    redeemed: {
      icon: "/images/status_paid.svg",
      color: "navy",
      title: "การชำระรออนุมัติ",
      texts: [
        "  ระบบได้รับหลักฐานการชำระเงินของท่านเรียบร้อยแล้ว!",

        "เจ้าหน้าที่จะทำการตรวจสอบและอนุมัติคำสั่งซื้อของท่านโดยเร็วที่สุด",

        "ท่านสามารถติดตามสถานะการสั่งซื้อของท่านได้ใน",
      ],
      button: (
        <Button
          margin="24px 0 0 0"
          width="100%"
          background="gradient2"
          hoverBg="transparent"
          hoverColor="navy"
          hoverBorder="navy"
          gap="8px"
          onClick={() => go("/point/history")}
        >
          ประวัติการใช้คะแนน
        </Button>
      ),
    },
    point_redeemed: {
      icon: "/images/status_paid.svg",
      color: "navy",
      title: "การชำระรออนุมัติ",
      texts: [
        "  ระบบได้รับหลักฐานการชำระเงินของท่านเรียบร้อยแล้ว!",

        "เจ้าหน้าที่จะทำการตรวจสอบและอนุมัติคำสั่งซื้อของท่านโดยเร็วที่สุด",

        "ท่านสามารถติดตามสถานะการสั่งซื้อของท่านได้ใน",
      ],
      button: (
        <Button
          margin="24px 0 0 0"
          width="100%"
          background="gradient2"
          hoverBg="transparent"
          hoverColor="navy"
          hoverBorder="navy"
          gap="8px"
          onClick={() => go("/point/history")}
        >
          ประวัติการใช้คะแนน
        </Button>
      ),
    },
    coupon_approved: {
      icon: "/images/status_paid.svg",
      color: "navy",
      title: "แลกคูปองสำเร็จ",
      texts: [
        "  ระบบได้รับหลักฐานการชำระเงินของท่านเรียบร้อยแล้ว!",

        "เจ้าหน้าที่จะทำการตรวจสอบและอนุมัติคำสั่งซื้อของท่านโดยเร็วที่สุด",

        "ท่านสามารถติดตามสถานะการสั่งซื้อของท่านได้ใน",
      ],
      button: (
        <Button
          margin="24px 0 0 0"
          width="100%"
          background="gradient2"
          hoverBg="transparent"
          hoverColor="navy"
          hoverBorder="navy"
          gap="8px"
          onClick={() => go("/coupon/history")}
        >
          ไปที่คูปองของฉัน
        </Button>
      ),
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!Object.keys(data).includes(status)) {
      go("/");
    }

    if (status === "pending_offline") {
      localStorage.setItem("lastUpdate.noti", Date.now());
    }

    if (status === "point_redeemed" && orderId) {
      getPointRedeemData();
    } else if (orderId) {
      getCouponData();
    }
  }, [status]);

  const getPointRedeemData = async () => {
    const pointRedeemData = await callApi("products-getTransaction", {
      orderId,
    });
    setTempData(pointRedeemData.data);
  };

  const getCouponData = async () => {
    const coupData = await callApi("coupons-getTransaction", { orderId });
    setTempData(coupData.data);
  };

  if (orderId) {
    return tempData ? (
      <Redeemed tempData={tempData} go={go} />
    ) : (
      <ModalLoading />
    );
  }

  return (
    <Flex direction="column" width="100%">
      <ProgressBar
        status={
          status === statuses.APPROVE ? 4 : status === "pending_offline" ? 2 : 3
        }
      />
      <Container>
        <ContentContainer minHeight="0px">
          <Flex justify="center" margin="0 0 32px 0">
            <img
              src={data[status]?.icon || ""}
              alt="icon"
              style={{ width: "100%", maxWidth: "250px" }}
            />
          </Flex>

          <Typo.H5
            margin="8px 0"
            color={data[status]?.color || "navy"}
            textAlign="center"
          >
            {data[status]?.title || ""}
          </Typo.H5>
          {data[status]?.texts.map((text, i) => (
            <Typo.Body3 key={i} textAlign="center" color="textBlack">
              {text}
            </Typo.Body3>
          ))}

          {status === "pending_offline" && (
            <>
              <Button background="red" width="100%" margin="25px 0 0 0">
                ติดต่อเจ้าหน้าที่
              </Button>

              <Typo.Body3 textAlign="center" color="textBlack" margin="15px 0">
                โดย
              </Typo.Body3>
              <Typo.Body3 textAlign="center" color="navy">
                โทร 02-246-6666
              </Typo.Body3>
            </>
          )}
        </ContentContainer>

        {data[status]?.button
          ? data[status]?.button
          : !localStorage.guestId && (
              <Button
                margin="24px 0 0 0"
                width="100%"
                background="gradient2"
                hoverBg="transparent"
                hoverColor="navy"
                hoverBorder="navy"
                gap="8px"
                onClick={() => go("/orders")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="19"
                  viewBox="0 0 20 19"
                  fill="none"
                >
                  <g clipPath="url(#clip0_91_29924)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.34482 1.20524C4.53004 1.86739 2.9832 2.45012 2.90744 2.50028C2.56378 2.72767 2.5377 3.04297 2.80194 3.77452L2.99299 4.30334H5.61798H8.24292L8.26264 3.44055C8.28748 2.35389 8.35816 2.10242 8.7612 1.66713C9.17763 1.21731 9.52376 1.07495 10.2682 1.04716C10.7212 1.03025 10.7778 1.02109 10.7566 0.967934C10.7435 0.934874 10.6906 0.790949 10.6391 0.648069C10.4684 0.174114 10.2559 -0.002491 9.85935 2.6496e-05C9.67163 0.001214 9.22826 0.153262 6.34482 1.20524ZM9.88571 2.15748C9.43793 2.28473 9.3662 2.46808 9.3662 3.48543V4.30334H12.6133H15.8604V3.48543C15.8604 2.45758 15.7895 2.2825 15.3222 2.15486C15.1277 2.10171 10.0733 2.10418 9.88571 2.15748ZM1.62888 5.43094C1.19915 5.53544 0.803665 5.85967 0.615042 6.26205L0.515625 6.47423V12.2076V17.941L0.62478 18.1637C0.764192 18.448 1.04805 18.732 1.33201 18.8711L1.55469 18.9801H9.1621H16.7695L16.9922 18.8709C17.2763 18.7316 17.5601 18.4478 17.6994 18.1637L17.8086 17.941L17.8194 16.466L17.8303 14.9908L16.4464 14.9896C14.7718 14.988 14.3863 14.9317 13.8601 14.6119C11.8063 13.364 12.1049 10.4055 14.3662 9.59641L14.6914 9.48008L16.2608 9.46863L17.8303 9.45714L17.8194 7.96568L17.8086 6.47423L17.7091 6.26205C17.5145 5.84685 17.0948 5.5143 16.6471 5.42063C16.3522 5.35898 1.88415 5.36886 1.62888 5.43094ZM14.8118 10.578C13.3301 10.9272 13.0969 13.0404 14.4659 13.7118C14.8653 13.9076 14.9572 13.9147 17.0807 13.9139C19.7618 13.9127 19.5025 14.0992 19.4884 12.1827L19.4785 10.8405L19.3857 10.7413C19.1893 10.5311 19.2643 10.5374 17.0218 10.5414C15.883 10.5435 14.8885 10.5599 14.8118 10.578ZM15.4495 11.7425C15.9515 12.002 15.7886 12.7414 15.2295 12.7414C14.9216 12.7414 14.71 12.5177 14.71 12.1922C14.71 11.828 15.1259 11.5751 15.4495 11.7425Z"
                      fill="#FFCD00"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_91_29924">
                      <rect
                        width="19"
                        height="19"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                กระเป๋าของฉัน
              </Button>
            )}
        {status === statuses.APPROVE && !localStorage.guestId && (
          <Button
            margin="24px 0 0 0"
            width="100%"
            background="transparent"
            hoverBg="transparent"
            color="navy"
            gap="8px"
            onClick={() => go("/")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <g clipPath="url(#clip0_91_28609)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.285934 0.769556C-0.0954912 1.02096 -0.107866 1.62024 0.262889 1.88276C0.353804 1.94711 0.553784 1.95805 1.97911 1.97708C3.71012 2.00013 3.71298 2.00046 3.90141 2.23162C4.01653 2.37286 4.07428 2.66662 5.15976 8.6372C5.77202 12.0049 6.28352 14.8095 6.29644 14.8696C6.31718 14.9663 6.28792 14.9993 6.04383 15.1549C4.77993 15.9607 4.86903 17.8293 6.2052 18.5374C6.32097 18.5987 6.44406 18.649 6.47877 18.649C6.5264 18.6489 6.53426 18.6778 6.51089 18.7671C5.85507 21.2754 9.4486 22.4077 10.2481 19.9446C10.3244 19.7096 10.3259 18.9844 10.2504 18.8101C10.2196 18.7388 10.3942 18.7349 13.5787 18.7349C16.7631 18.7349 16.9377 18.7388 16.9069 18.8101C16.7667 19.1341 16.8561 19.9557 17.0716 20.3247C18.2425 22.3293 21.2674 21.0443 20.6402 18.8087C20.5738 18.5721 20.5738 18.5464 20.6402 18.4341C20.7387 18.2674 20.7339 17.889 20.6314 17.7335C20.4407 17.4443 21.0553 17.4695 13.6431 17.4458C7.03575 17.4246 6.93796 17.4231 6.79738 17.3384C6.38532 17.0901 6.38532 16.5125 6.79738 16.2642C6.9378 16.1796 7.03608 16.1779 13.1705 16.1564C17.7528 16.1403 19.4375 16.1213 19.5393 16.0846C20.1962 15.8472 20.6986 15.2762 20.8371 14.6099C20.9147 14.2361 22.0006 5.44285 22.0003 5.1904C21.9999 4.93597 21.913 4.76718 21.7151 4.63672C21.596 4.55812 21.3587 4.55576 13.6849 4.55548L5.77746 4.55515L5.55581 3.3413C5.21949 1.49908 4.95945 1.05677 4.04584 0.772856C3.6356 0.645366 0.478434 0.642616 0.285934 0.769556ZM20.5826 5.93153C20.5826 6.18607 19.5346 14.3513 19.4874 14.4646C19.4567 14.5383 19.3585 14.6543 19.2692 14.7223L19.1069 14.8462L13.3815 14.8579L7.65621 14.8695L7.63168 14.7504C7.61815 14.6849 7.25856 12.7074 6.83258 10.3559C6.40655 8.00448 6.04707 6.02739 6.03365 5.96238L6.00934 5.84424H13.296H20.5826V5.93153ZM9.30934 7.21484C9.00783 7.41361 9.02455 7.22953 9.02455 10.3559C9.02455 13.0409 9.02829 13.1761 9.10551 13.2932C9.3644 13.6859 9.97264 13.6859 10.2315 13.2932C10.3574 13.1023 10.3574 7.60963 10.2315 7.41867C10.0992 7.21803 9.93288 7.13388 9.66849 7.13388C9.5091 7.13388 9.39223 7.16023 9.30934 7.21484ZM13.2625 7.21484C12.961 7.41361 12.9777 7.22953 12.9777 10.3559C12.9777 13.0409 12.9814 13.1761 13.0586 13.2932C13.3175 13.6859 13.9258 13.6859 14.1846 13.2932C14.2619 13.1761 14.2656 13.0409 14.2656 10.3559C14.2656 7.67101 14.2619 7.53588 14.1846 7.41867C14.0523 7.21803 13.886 7.13388 13.6216 7.13388C13.4622 7.13388 13.3454 7.16023 13.2625 7.21484ZM17.1297 7.21484C16.8282 7.41361 16.8448 7.22953 16.8448 10.3559C16.8448 13.0409 16.8486 13.1761 16.9259 13.2932C17.1847 13.6859 17.7929 13.6859 18.0518 13.2932C18.129 13.1761 18.1328 13.0409 18.1328 10.3559C18.1328 7.67101 18.129 7.53588 18.0518 7.41867C17.9195 7.21803 17.7532 7.13388 17.4888 7.13388C17.3294 7.13388 17.2125 7.16023 17.1297 7.21484ZM8.69565 18.8594C9.21084 19.1991 8.99045 19.9804 8.37946 19.9804C8.03367 19.9804 7.77847 19.7251 7.77847 19.3794C7.77847 19.0336 8.03367 18.7784 8.37946 18.7784C8.49677 18.7784 8.62113 18.8103 8.69565 18.8594ZM19.0941 18.8594C19.2816 18.983 19.3789 19.1606 19.3789 19.3794C19.3789 19.5982 19.2816 19.7757 19.0941 19.8994C18.8341 20.0708 18.4423 19.9753 18.2578 19.6956C18.0865 19.4356 18.1819 19.0438 18.4617 18.8594C18.5362 18.8103 18.6606 18.7784 18.7779 18.7784C18.8952 18.7784 19.0195 18.8103 19.0941 18.8594Z"
                  fill="#003A9E"
                />
              </g>
              <defs>
                <clipPath id="clip0_91_28609">
                  <rect width="22" height="22" fill="white" />
                </clipPath>
              </defs>
            </svg>
            ซื้อลอตเตอรี่เพิ่ม
          </Button>
        )}
      </Container>
    </Flex>
  );
};

export const Redeemed = ({ tempData, go }) => {
  return (
    <Flex direction="column" width="100%">
      <ProgressBar status={4} />
      <Container>
        <ContentContainer minHeight="0px">
          <Flex justify="center" margin="0 0 32px 0">
            <img
              src="/images/status_redeemed.svg"
              alt="icon"
              style={{ width: "100%", maxWidth: "450px" }}
            />
          </Flex>
          {tempData.pointAfterCharge >= 0 && (
            <Typo.H6 textAlign="center" color="navy">
              แลกคะแนนสำเร็จ
            </Typo.H6>
          )}
          {tempData.coupon?.expireAt && (
            <Flex
              padding="15px"
              border="2px dashed #C4C4C4"
              margin="25px 0 0 0"
              gap="10px"
              align="center"
              direction="column"
            >
              <Typo.Body2 color="textBlack">
                {tempData.coupon?.name} มูลค่า{" "}
                {tempData.coupon?.price ||
                  tempData.product?.price ||
                  tempData.coupon?.price}{" "}
                คะแนน
              </Typo.Body2>
              <Typo.Body3 color="gray4">
                คูปองหมดอายุ{" "}
                {new Date(tempData.coupon.expireAt).toLocaleDateString(
                  "th-TH",
                  {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                  }
                )}
              </Typo.Body3>
            </Flex>
          )}

          {tempData.product && (
            <Flex
              padding="15px"
              border="2px dashed #C4C4C4"
              margin="25px 0 0 0"
              gap="10px"
              align="center"
              direction="column"
            >
              <Typo.Body2 color="textBlack">
                {tempData.product?.name} มูลค่า{" "}
                {tempData.product?.price || tempData.product?.point} คะแนน
              </Typo.Body2>
              {/* <Typo.Body3 color="gray4">
                คูปองหมดอายุ{" "}
                {getThaiDateFormat(new Date(tempData.coupon?.expireAtDate))}
              </Typo.Body3> */}
            </Flex>
          )}
          {tempData.pointAfterCharge >= 0 && (
            <Flex margin="25px 0 0 0" gap="10px" justify="center">
              <Typo.Body5 color="textBlack">คะแนนสะสมคงเหลือ</Typo.Body5>
              <Typo.Body3 color="navy">
                {tempData.pointAfterCharge?.toLocaleString()} คะแนน
              </Typo.Body3>
            </Flex>
          )}
          <Button
            margin="24px 0 0 0"
            width="100%"
            background="gradient2"
            hoverBg="transparent"
            hoverColor="navy"
            hoverBorder="navy"
            onClick={() =>
              tempData.coupon
                ? window.open("/coupon/my_coupon", "_self")
                : window.open("/point/history", "_self")
            }
          >
            {tempData.coupon ? "ไปที่คูปองของฉัน" : "ประวัติการแลกคะแนน"}
          </Button>
        </ContentContainer>
      </Container>
    </Flex>
  );
};
